import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import TextField from '@mui/material/TextField';

import InputAdornment from '@mui/material/InputAdornment';

import { FiDelete } from 'react-icons/fi';

interface Props {
  getCoords: React.Dispatch<React.SetStateAction<any>>;
  setActiveLocationName: React.Dispatch<React.SetStateAction<string>>;
  className?: string;
  outterClassName?: string;
  activeLocationName: string;
}

interface State {
  address: string;
}

class LocationSearchInput extends React.Component<Props, State> {
  private inputRef: React.RefObject<HTMLInputElement>;

  constructor(props: Props) {
    super(props);
    this.state = { address: '' };
    this.inputRef = React.createRef<HTMLInputElement>();
  }

  handleChange = (address: string) => {
    if (!address.trim()) { // check if the input is empty or only contains whitespace
      this.props.getCoords({ lat: '', lng: '' });
      this.props.setActiveLocationName(address);
    }
    this.setState({ address });
  };

  handleSelect = (address: string) => {
    if (!address.trim()) { // check if the input is empty or only contains whitespace
      this.props.getCoords({ lat: '', lng: '' });
      this.props.setActiveLocationName(address);
      this.setState({ address });
      return;
    }
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        this.props.getCoords(latLng);
        this.props.setActiveLocationName(address);
        this.setState({ address });
      })
      .catch(error => console.error('Error', error));
  };

  clear = () => {
    this.setState({ address: '' });
    if (this.inputRef.current) {
      this.inputRef.current.value = '';
    }
  };

  render() {
    return (
      <div className={this.props.outterClassName}>
        <PlacesAutocomplete
          value={this.state.address}
          onChange={this.handleChange}
          onSelect={this.handleSelect}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div>

              <div className='flex flex-row items-center justify-center space-x-2'>
                <TextField
                  className={this.props.className}
                  {...getInputProps({
                    label: 'Search Places ...',
                    variant: 'outlined',
                    fullWidth: true,
                    inputRef: this.inputRef,
                  })}
                  value={this.state.address}
                />
                {
                  this.props.activeLocationName !== '' && (
                    <div className='w-[30px] flex justify-center items-center cursor-pointer'>
                      <FiDelete onClick={() => {
                        this.props.setActiveLocationName(''); 
                        this.props.getCoords({ lat: '', lng: '' });
                        this.setState({address: ''});
                      }} className='text-[22px] hover:text-[25px] text-gray-500'></FiDelete>
                    </div>
                  )

                }

              </div>

              {this.inputRef.current && this.inputRef.current.value !== '' ? (
                <div style={{ position: 'relative' }}>
                  <div
                    style={{
                      borderRadius: '3px',
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      maxHeight: '200px',
                      overflowY: 'auto',
                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                      backgroundColor: 'white',
                      zIndex: 10
                    }}
                    className='divide-y-2'
                  >
                    {loading && (
                      <div className="flex justify-center items-center min-h-[50px]">
                        Loading...
                      </div>
                    )}
                    {suggestions.map((suggestion, index) => {
                      const className = suggestion.active
                        ? 'suggestion-item--active bg-blue-500'
                        : 'suggestion-item bg-white';
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style: {
                              cursor: 'pointer',
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              backgroundColor: 'transparent',
                              transition: 'background-color 0.3s',
                              ':hover': {
                                backgroundColor: '#00a1ed',
                                color: 'white'
                              },
                            },
                          })}
                          key={index}
                          className='bg-white hover:bg-[#00a1ed] hover:text-white'
                        >
                          <span className="block px-4 py-2">{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </PlacesAutocomplete>
      </div>
    );
  }
}

export default LocationSearchInput;
